<template>
  <div id="mask"></div>
  <MainComonent/>
</template>

<script>
import MainComonent from './components/MainComonent.vue'

export default {
  name: 'App',
  components: {
    MainComonent
  }
}
</script>

<style>
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url('assets/images/backgrounds/black_bcg.jpg');
  
  font-size: 2.2vh;
  font-weight:900;

  /* Center and scale the image nicely */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  z-index: -2;
  overflow: hidden
}
#mask{
  background: black;
  opacity: 0.7;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;

}
.full-height-image{
  position:absolute;
  left: 0;
  bottom: -5vh;
  right: 0;
  margin:auto;
  width:25vw;
  max-width:250px;

}
</style>
